/** 계약 관련 유틸 */
import { PAY_STATEMENT_TYPE_CODE } from '../constants';
import { TypePayStatementByMonth, TypePayStatementDetailByEtc, TypePayStatementDetailByPerDiem } from '../hooks';
import { TypePayStatementDetailMap, TypePayStatementType } from '../types';

/** @description 급여명세서 상세페이지 > '가타' 급여명세서인지 확인 및 타입 가드를 위한 메소드 */
export const isEtcDetail = (
  detail: TypePayStatementDetailMap[TypePayStatementType],
  type: TypePayStatementType
): detail is TypePayStatementDetailByEtc => {
  return [
    PAY_STATEMENT_TYPE_CODE.HOLIDAY,
    PAY_STATEMENT_TYPE_CODE.ANNUAL,
    PAY_STATEMENT_TYPE_CODE.SPECIAL_PRO,
  ].includes(type);
};

/** @description 급여명세서 상세페이지 > '일별' 급여명세서인지 확인 및 타입 가드를 위한 메소드 */
export const isPerDiemDetail = (
  detail: TypePayStatementDetailMap[TypePayStatementType],
  type: TypePayStatementType
): detail is TypePayStatementDetailByPerDiem => {
  return type === PAY_STATEMENT_TYPE_CODE.PER_DIEM;
};

/** @description 급여명세서 상세페이지 > '월별' 급여명세서인지 확인 및 타입 가드를 위한 메소드 */
export const isMonthlyDetail = (
  detail: TypePayStatementDetailMap[TypePayStatementType],
  type: TypePayStatementType
): detail is TypePayStatementByMonth => {
  return type === PAY_STATEMENT_TYPE_CODE.MONTHLY;
};
